import React, { useEffect, useState } from "react";
import useStore from "../../store";
import "./LanguageSwitch.css";
import MaterialIcon from "../MaterialIcon/MaterialIcon";

const LanguageSwitch = () => {
  const lang = useStore((state) => state.lang);
  const setLang = useStore((state) => state.setLang);
  const availableLanguages = useStore((state) => state.availableLanguages);
  const fetchLanguages = useStore((state) => state.fetchLanguages);

  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    fetchLanguages();
  }, []);

  useEffect(() => {
    console.log("Lang changed", lang, availableLanguages);
    if (isOpen) setIsOpen(false);
  }, [lang]);

  const toggleDropdown = () => setIsOpen(!isOpen);

  return (
    <div className="LanguageSwitch">
      <button className="dropdown-toggle" onClick={toggleDropdown}>
        <MaterialIcon name="language" className={"globe"} />
        {lang}
      </button>
      {isOpen && (
        <ul className="dropdown-menu">
          {availableLanguages.map((language) => (
            <li key={language.code}>
              <button
                className={lang === language.code ? "current" : ""}
                onClick={() => {
                  setLang(language.code);
                  setIsOpen(false);
                }}
              >
                {language.name}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default LanguageSwitch;
